export default __webpack_public_path__ + "d87151d1cf1a51fb98df55fc5c6bfe4f.png";